export var JobStepName;
(function (JobStepName) {
    JobStepName["JOB_STEP_NAME_CREATE_VM_SNAPSHOT"] = "CREATE_VM_SNAPSHOT";
    JobStepName["JOB_STEP_NAME_CREATE_DDB_TABLE"] = "CREATE_DDB_TABLE";
    JobStepName["JOB_STEP_NAME_WRITE_DDB_DATA"] = "WRITE_DDB_DATA";
    JobStepName["JOB_STEP_NAME_RESTORE_DDB_CONFIG"] = "RESTORE_DDB_CONFIG";
    JobStepName["JOB_STEP_NAME_RECREATE_DDB_GSIS"] = "RECREATE_DDB_GSIS";
})(JobStepName || (JobStepName = {}));
